import { HTTP_INTERCEPTORS, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { CorrelationIdService } from '../_services/correlation-id.service';

const CORRELATION_ID_HEADER = 'X-Correlation-Id';

@Injectable()
export class CorrelationIdInterceptor implements HttpInterceptor {

  constructor(private correlationIdService: CorrelationIdService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authReq = req.clone({
      headers: req.headers.set(CORRELATION_ID_HEADER, this.correlationIdService.getCorrelationId())
    });

    return next.handle(authReq).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const serverCid = event.headers.get(CORRELATION_ID_HEADER);
          this.correlationIdService.syncFromServer(serverCid);
        }
      })
    );
  }
}

export const correlationIdInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: CorrelationIdInterceptor, multi: true }
];
